/**
 * Include your custom JavaScript here.
 * 
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// add to cart event
function addToCart(variant_id, handle, variant) {
  data = {
    "id": variant_id,
    "quantity": 1
  }

  $.ajax({
    type: 'POST',
    url: "".concat(window.routes.cartAddUrl, ".js"),
    data: data,
    dataType: 'json',
    error: function () {
      $( "#error_addtocart" ).show().delay(3000).fadeOut();
    },
    success: function () {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
      
      $.ajax({
        url: location.origin + '/products/' + handle + '.json',
        success: function(data) {
          addCartCollection(data.product, variant);
        }
      });
      
    },
  });
};



function showGallery(el) {
  let cont = el.split('--');
  let element = document.body.querySelector('.info[data-info=' + el + ']');
  let container = document.body.querySelector('.main-info[data-info=' + cont[1] + ']');
  element.classList.remove("hidden");
  container.classList.add("hidden");
}

function closeGallery(el) {
  let cont = el.split('--');
  let element = document.body.querySelector('.info[data-info=' + el + ']');
  let container = document.body.querySelector('.main-info[data-info=' + cont[1] + ']');
  container.classList.remove("hidden");
  element.classList.add("hidden");
}

function showGalleryVideo(el) {
  $(".info-video").addClass("hidden");
  let element = document.body.querySelector('.info[data-info=' + el + ']');
  element.classList.remove("hidden");
}

function closeGalleryVideo(el) {  
  let element = document.body.querySelector('.info[data-info=' + el + ']');
  element.classList.add("hidden");
}


// blog scroll
$(document).ready(function() {
  $('.GalleryDays__Container').each(function() {
    var ownheight = $(this).height();
    $(this).css({'height': (ownheight + 52) + 'px'});
  });
    
  /* klaviyo change status button */
  $('.ProductForm__BuyButtons').on('load DOMSubtreeModified', function(){
    var attr = $('.ProductForm__AddToCart').attr('disabled');
    if ($( ".ProductForm__AddToCart" ).hasClass( "Button--secondary" )){
      if (typeof attr !== typeof undefined && attr !== false) {
        $( "#KlaviyoButton" ).show();
        $( ".ProductForm__AddToCart" ).hide();
      } else {
        $( ".ProductForm__AddToCart" ).show();
        $( "#KlaviyoButton" ).hide();
      }
    } else {
      $( ".ProductForm__AddToCart" ).show();
      $( "#KlaviyoButton" ).hide();
    }
  });

  /* klaviyo mini */
  let url = new URL(window.location.href);
  if (url.searchParams.get('popup-mini')) {
    window._klOnsite = window._klOnsite || []; 
    window._klOnsite.push(['openForm', 'TvuFHr']);
  }
  
  //parallax scroll
  $(window).on("load scroll", function() {
    if($( window ).width() > 1007) {
      var parallaxElement = $(".ArticleList .Grid__Cell").filter(":nth-child(3n+1), :nth-child(3n+3)"),
          parallaxQuantity = parallaxElement.length;
    } else {
      var parallaxElement = $(".ArticleList .Grid__Cell:nth-child(2n+1)"),
          parallaxQuantity = parallaxElement.length;
    }
    
    window.requestAnimationFrame(function() {
      for (var i = 0; i < parallaxQuantity; i++) {
        var currentElement = parallaxElement.eq(i),
            windowTop = $(window).scrollTop(),
            //elementTop = currentElement.offset().top,
            elementHeight = currentElement.height(),
            viewPortHeight = window.innerHeight * 0.5 - elementHeight * 0.5,
            scrolled = windowTop + viewPortHeight;
            if($( window ).width() > 1007) {
              currentElement.css({
                transform: "translate3d(0," + scrolled * -0.3 + "px, 0)"
              });
            } else {
              currentElement.css({
                transform: "translate3d(0," + scrolled * -0.2 + "px, 0)"
              });
            }
      }
    });
  });

  $("[data-submenu-parent]").on('click', function(event) {
    let submenu = $(this).next();
    let icon = $(this).children().children(".open-submenu").children();
    event.preventDefault();
    if (submenu.css('display') == 'none') {
      submenu.css("display", "block");
      icon.css({
        "-webkit-transform": "rotate(180deg)",
        "-moz-transform": "rotate(180deg)",
        "transform": "rotate(180deg)"
      });
    } else {
      submenu.css("display", "none");
      icon.css({
        "-webkit-transform": "rotate(360deg)",
        "-moz-transform": "rotate(360deg)",
        "transform": "rotate(360deg)"
      });
    }
  });

  if($('.template-index #main').length){
    var timeout = null;
    $('.template-index #main').on('mousemove', function() {
        if (timeout !== null) {
            $("#fp-nav").removeClass('opacity');
            clearTimeout(timeout);
        }
    
        timeout = setTimeout(function() {
            if ( $("#fp-nav:hover").length <= 0 ) {
              $("#fp-nav").addClass('opacity');
            }
        }, 800);
    });
  }
  
});

$(document).ready(function () {

  function timermaker() {
    //var endTimeC = new Date(Date.UTC(2023, 0, 15, 22, 59, 59));
    
    var endTimeC = new Date();
    endTimeC.setHours(23,59,59);
    
    endTimeC = (Date.parse(endTimeC) / 1000);
    
    var now = new Date();
    now = (Date.parse(now) / 1000);

    var timeLeft = endTimeC - now;
    var days = Math.floor(timeLeft / 86400); 
    var hours = (Math.floor((timeLeft - (days * 86400)) / 3600)) + (24 * days);
    var hoursAux = Math.floor((timeLeft - (days * 86400)) / 3600);
    var minutes = Math.floor((timeLeft - (days * 86400) - (hoursAux * 3600 )) / 60);
    var seconds = Math.floor((timeLeft - (days * 86400) - (hoursAux * 3600) - (minutes * 60)));

    if (days < "10") { days = "0" + days; }
    if (hours < "10") { hours = "0" + hours; }
    if (minutes < "10") { minutes = "0" + minutes; }
    if (seconds < "10") { seconds = "0" + seconds; }
    $("div:not(#AnnouncementCountdown):not(.BannerCountdown) > .days").html(days + "<span>:</span>");
    $("div:not(#AnnouncementCountdown):not(.BannerCountdown) > .hours").html(hours + "<span>:</span>");
    $("div:not(#AnnouncementCountdown):not(.BannerCountdown) > .minutes").html(minutes + "<span>:</span>");
    $("div:not(#AnnouncementCountdown):not(.BannerCountdown) > .seconds").html(seconds);    
  }
  setInterval(function() { timermaker(); }, 1000);


  function timermakerannouncement() {
    //var endTime = new Date(Date.UTC(2023, 0, 15, 22, 59, 59));
    
    var endTime = new Date();
    endTime.setHours(23,59,59);
    
    endTime = (Date.parse(endTime) / 1000);

    var now = new Date();
    now = (Date.parse(now) / 1000);

    var timeLeft = endTime - now;
    var days = Math.floor(timeLeft / 86400); 
    var hours = (Math.floor((timeLeft - (days * 86400)) / 3600)) + (24 * days);
    var hoursAux = Math.floor((timeLeft - (days * 86400)) / 3600);
    var minutes = Math.floor((timeLeft - (days * 86400) - (hoursAux * 3600 )) / 60);
    var seconds = Math.floor((timeLeft - (days * 86400) - (hoursAux * 3600) - (minutes * 60)));

    if (days < "10") { days = "0" + days; }
    if (hours < "10") { hours = "0" + hours; }
    if (minutes < "10") { minutes = "0" + minutes; }
    if (seconds < "10") { seconds = "0" + seconds; }
    /*$("#AnnouncementCountdown .days").html(days + "<span>:</span>");*/
    $("#AnnouncementCountdown .hours").html(hours + "<span>:</span>");
    $("#AnnouncementCountdown .minutes").html(minutes + "<span>:</span>");
    $("#AnnouncementCountdown .seconds").html(seconds);    
  }
  
  setInterval(function() { timermakerannouncement(); }, 1000);

  if($('#AnnouncementBar3').length && $('#AnnouncementBar2').length) {
    var counter = 1;
    var messages = $('.AnnouncementBar__Content');
    setInterval(function(){
      if(counter === $('.AnnouncementBar__Content').length) {
        $(messages[messages.length - 1]).hide();
        counter = 0;
      }

      if($(messages[counter - 1])) {
        $(messages[counter - 1]).hide();
      }
      
      $(messages[counter]).show();
      counter += 1;
      
    },3000);
  } else if($('#AnnouncementBar2').length){
    setInterval(function(){
    $("#AnnouncementBar2").is(":visible") ? $("#AnnouncementBar2").hide() : $("#AnnouncementBar2").show();
    $("#AnnouncementBar1").is(":visible") ? $("#AnnouncementBar1").hide() : $("#AnnouncementBar1").show();
    },3000);
  }


  let list = document.querySelectorAll('[data-gsap-options]');
  for (let item of list) {
    let attr = JSON.parse(item.getAttribute('data-gsap-options'));

    gsap.registerPlugin(ScrollTrigger);
    //ScrollTrigger.saveStyles(".move, .line, .fade-fromMarginRight, .fade-fromMarginLeft");
  
    const rows = attr.rows;
    const columns = attr.columns;
    const missingImages = attr.missingImages; // The number of missing images in the last row
    const frame_count = rows * columns - missingImages  - 1;
    // const imageWidth = 11580;
    // const imageHeight = 11550;
    const imageWidth = attr.imageWidth;
    const imageHeight = attr.imageHeight;
    const horizDiff = imageWidth / columns;
    const vertDiff = imageHeight / rows;
    
    const viewer = document.querySelector(attr.id);
    const ctx = viewer.getContext("2d");
    viewer.width = horizDiff;
    viewer.height = vertDiff;
    
    const image = new Image();
    image.src = attr.image_src;
    image.onload = () => onUpdate();
    
    // gsap.set(".viewer-one", {width: horizDiff, height: vertDiff});
    
    const setPos = gsap.quickSetter(".viewer-one", "background-position");
    
    const obj = {num: 0};
    gsap.to(obj, {
      num: frame_count,
      ease: "steps(" + frame_count + ")",
      scrollTrigger: {
        trigger: ".Section__One",
        start: "top top",
        end: "+=" + 3400,
        pin: attr.pin,
        anticipatePin: 1,
        scrub: 1
      },
      onUpdate
    }); 

    

    function onUpdate() {
      ctx.clearRect(0, 0, horizDiff, vertDiff);
      const x = Math.round((obj.num % columns) * horizDiff);
      const y = Math.round(Math.floor(obj.num / columns) * vertDiff);
      ctx.drawImage(image, x, y, horizDiff, vertDiff, 0, 0, horizDiff, vertDiff);
    }
  }
  
  $('.readmore').click(function (event) {
    event.preventDefault();
    var descriptionFull = document.querySelector('.product-description-full');
    descriptionFull.style.display = 'block';
    var descriptionShort = document.querySelector('.product-description-short');
    descriptionShort.style.display = 'none';
  });
  $('.readless').click(function (event) {
    event.preventDefault();
    var descriptionFull = document.querySelector('.product-description-full');
    descriptionFull.style.display = 'none';
    var descriptionShort = document.querySelector('.product-description-short');
    descriptionShort.style.display = 'block';
  });  

  $(".icon-cpage").click(function() {
    var container = $(this).next().find(".ProductList"), x;
    x = ((container.width() / 1.16)) + container.scrollLeft();
    container.animate({
      scrollLeft: x,
    })
  })

});